import { modelCatalogModel } from '@/stores/models';
import { getRuntimeConfig } from '@/util/modelCatalog';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

/**
 * Loads the runtime model catalog once at boot.
 *
 * Call this exactly once, near the root of the tree. `getRuntimeConfig` never
 * rejects: a missing or malformed `models.json` resolves to the built-in list,
 * so the dropdown is always populated. It is also the same single-flight fetch
 * the API base URL and WebSocket host resolution await (ISSUE-026), so the
 * whole boot configuration costs one round trip.
 */
const useModelCatalog = () => {
  const setCatalog = useSetRecoilState(modelCatalogModel);

  useEffect(() => {
    let cancelled = false;

    getRuntimeConfig().then(({ catalog }) => {
      if (!cancelled) setCatalog(catalog);
    });

    return () => {
      cancelled = true;
    };
  }, [setCatalog]);
};

export default useModelCatalog;
